import Public from '@assets/icons/public.svg'
import { Icon } from './Icon'

export const PublicIcon = Icon(Public)
